import React from "react";

const clients = [
  {
    name: "Boston Public Library",
    src: "/bpl-logo.png",
  },
  {
    name: "IFFBoston",
    src: "/iffb-logo.png",
  },
  {
    name: "Somerville Theatre",
    src: "/somerville-theatre-logo.png",
  },
  {
    name: "Capitol Theatre",
    src: "/capitol-theatre-logo.png",
  },
  {
    name: "Hot Glue Heroes",
    src: "/hgh-logo.jpg",
  },
];

export const Clients = () => {
  return (
    <section
      id="clients"
      className="section-divider radio-waves relative"
      style={{ "--rw-x": "100%", "--rw-y": "50%" }}
      data-testid="clients-section"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mb-8">
          Past Clients
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="clients-grid">
          {clients.map((c, i) => (
            <div
              key={c.name}
              className="rounded-[14px] flex items-center justify-center p-5"
              style={{
                background: "var(--bpm-cream)",
                border: "1px solid var(--bpm-line-strong)",
                aspectRatio: "1 / 1",
              }}
              data-testid={`client-${i}`}
            >
              <img
                src={c.src}
                alt={c.name}
                title={c.name}
                className="block w-full h-full"
                style={{ objectFit: "contain" }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
